export default __webpack_public_path__ + "static/media/Mufarrah_Malik.c515a697.png";